// extracted by mini-css-extract-plugin
export default {"heading-container":"category-heading__heading-container--CM999","headingContainer":"category-heading__heading-container--CM999","column":"category-heading__column--Y64Sy"};